import { CheckIcon, ChevronDownIcon } from "./Icons.js";

export function TrustPoints({ items }: { items: { icon: any; text: string }[] }) {
  return (
    <div className="trust-points">
      {items.map((item, i) => (
        <span className="trust-point" key={i}>
          {item.icon}
          {item.text}
        </span>
      ))}
    </div>
  );
}

export function TrustItem({ icon, title, desc }: { icon: any; title: string; desc: string }) {
  return (
    <div className="trust-item">
      <div className="trust-item__icon">{icon}</div>
      <div>
        <div className="trust-item__title">{title}</div>
        <p className="trust-item__desc">{desc}</p>
      </div>
    </div>
  );
}

export function ProcessSteps({
  steps,
}: {
  steps: { title: string; desc: string }[];
}) {
  return (
    <div className="process-steps">
      {steps.map((s, i) => (
        <div className="process-step" key={i}>
          <div className="process-step__num">{i + 1}</div>
          <div className="process-step__title">{s.title}</div>
          <p className="process-step__desc">{s.desc}</p>
        </div>
      ))}
    </div>
  );
}

export function Breadcrumbs({ items }: { items: { name: string; path: string }[] }) {
  return (
    <nav className="breadcrumbs" aria-label="Kruimelpad">
      {items.map((item, i) => (
        <span key={item.path}>
          {i > 0 && <span aria-hidden="true">/</span>}
          {i === items.length - 1 ? (
            <span aria-current="page">{item.name}</span>
          ) : (
            <a href={item.path}>{item.name}</a>
          )}
        </span>
      ))}
    </nav>
  );
}

export interface FaqItemData {
  id: string | number;
  question: string;
  answer: string;
}

export function FAQList({ items, headingLevel = "h3" }: { items: FaqItemData[]; headingLevel?: "h2" | "h3" }) {
  const Heading = headingLevel as any;
  return (
    <div data-faq-list>
      {items.map((item, i) => (
        <div className="faq-item" key={item.id} data-faq-item data-open={i === 0 ? "true" : "false"}>
          <Heading style={{ margin: 0, fontSize: "inherit" }}>
            <button type="button" className="faq-item__question" data-faq-trigger aria-expanded={i === 0}>
              <span>{item.question}</span>
              <ChevronDownIcon size={20} className="faq-item__icon" />
            </button>
          </Heading>
          <div className="faq-item__answer" data-faq-answer>
            <div className="faq-item__answer-inner" dangerouslySetInnerHTML={{ __html: item.answer }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function CTABanner({
  title,
  buttonLabel,
  buttonHref,
  icon,
}: {
  title: string;
  buttonLabel: string;
  buttonHref: string;
  icon: any;
}) {
  return (
    <div className="cta-banner">
      <div className="cta-banner__left">
        <div className="cta-banner__icon">{icon}</div>
        <h2>{title}</h2>
      </div>
      <a href={buttonHref} className="btn btn-primary btn-lg" data-event="cta_banner_click">
        {buttonLabel}
      </a>
    </div>
  );
}

export function IncludedList({ notes }: { notes: string[] }) {
  return (
    <ul className="price-summary__notes">
      {notes.map((n, i) => (
        <li key={i}>
          <CheckIcon size={16} /> {n}
        </li>
      ))}
    </ul>
  );
}
